module.exports = "/images/markerMobile.svg";